import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const UINotificationRecord = Record({
  type: null,
  label: null,
  actions: List()
});

// Custom implementation because we don't want actions to pass
// through fromJS themselves!
createFromJS.registerCallback("UINotificationRecord", any => {
  return new UINotificationRecord(any).set(
    "actions",
    List(any.actions).map(a => createFromJS.UINotificationActionRecord(a))
  );
});
